/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Row, Col } from "react-awesome-styled-grid";
import { Button, FlexContainer, Heading } from "@nordcloud/gnui";
import { Card } from "~/components";
import { EnvironmentItem } from "./EnvironmentItem";
import { AddEnvironmentSidebar } from "./EnvironmentSidebars";
import { Env } from "./types";

type Props = {
  applicationId: string;
  ownerId: string;
  environments: Env[];
  onSkip: () => void;
};

export function ApplicationEnvironmentsForm({
  applicationId,
  ownerId,
  environments,
  onSkip,
}: Props) {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  return (
    <>
      <Row>
        <Col sm={8} md={6} offset={{ sm: 0, md: 1 }}>
          {environments.length === 0 ? (
            <FlexContainer>
              <Card
                title="Application Environments"
                caption="Add Environments"
                description="add environments to the application manually and set
          up the rules for cost allocation and automate
          application discovery"
                onClick={() => setIsSidebarOpen(true)}
              />
              <Card
                title="Application Environments"
                caption="Skip adding Environment"
                description="skip adding the environments, the system will create
          default environment within your application
          automatically"
                onClick={onSkip}
              />
            </FlexContainer>
          ) : (
            <>
              <Heading level={4} mb="1rem">
                Application Environments
              </Heading>
              {environments.map((environment: Env) => (
                <EnvironmentItem
                  key={environment?.nid}
                  environment={environment}
                />
              ))}
              <FlexContainer>
                <Button
                  mt="0.75rem"
                  severity="medium"
                  icon="plus"
                  onClick={() => setIsSidebarOpen(true)}
                >
                  Add Environment
                </Button>
              </FlexContainer>
            </>
          )}
        </Col>
      </Row>
      <AddEnvironmentSidebar
        setIsSidebarOpen={setIsSidebarOpen}
        isSidebarOpen={isSidebarOpen}
        applicationNid={applicationId}
        applicationOwnerId={ownerId}
      />
    </>
  );
}
